<template>
  <div>
    <party-list v-show="activeKey===1" ref="list" :data-sources="dataSources" :owners="owners" :type="type" @add="add" @edit="edit"/>
    <party-detail v-show="activeKey===2" ref="detail" :classifications="classifications" :data-sources="dataSources" :owners="owners" :party-types="partyTypes" :pickup-modes="pickupModes" :regions="regions" :turnover-modes="turnoverModes" :type="type" @back="back"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import PartyList from '@/views/basedata/parties/PartyList.vue'
import PartyDetail from '@/views/basedata/parties/PartyDetail.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'PartyTemplate',
  components: { PartyList, PartyDetail },
  props: {
    type: { type: Number, default: null }
  },
  data() {
    return {
      activeKey: 1,
      partyTypes: [],
      classifications: [],
      regions: [],
      dataSources: [],
      turnoverModes: [],
      pickupModes: [],
      owners: []
    }
  },
  created() {
    getDictionaries('PARTY_TYPE').then(result => {
      this.partyTypes = result
      return getDictionaries('CUSTOMER_CLASSIFICATION')
    }).then(result => {
      this.classifications = result
      return getDictionaries('REGION')
    }).then(result => {
      this.regions = result
      return getEnums('DataSource')
    }).then(result => {
      this.dataSources = result
      return getEnums('TurnoverMode')
    }).then(result => {
      this.turnoverModes = result
      return getDictionaries('PICKUP_MODE')
    }).then(result => {
      this.pickupModes = result
      if (this.type > 1) {
        findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
          if (res.success) {
            this.owners = getOptions(res.result)
          }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    }
  }
}
</script>